export default "__VITE_ASSET__c14332ec__"